export default __webpack_public_path__ + "static/media/backer-bbs.5d159026.png";